import * as React from 'react';

import StoresTable from './StoresTable';
import { withRouter, RouteComponentProps } from 'react-router';

class Stores extends React.Component<RouteComponentProps> {

  public render() {
    const domain = (this.props as any).match.params.eshop;
    const storeId = (this.props as any).match.params.storeId;

    return (
      <div>
        <StoresTable domain={domain} storeId={storeId} />
      </div>
    );
  }
}

export default withRouter(Stores);


// WEBPACK FOOTER //
// ./src/scenes/Stores/index.tsx